module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_7016.cae8d0c1.png";